export default __webpack_public_path__ + "static/media/business_list_not_found.112a8c67.svg";